<template>
  <div class="map__overlay">
    <div class="map__overlay--box">
      <p>
        {{ noResultsTranslate() }}
      </p>
      <button class="base-button" @click="allowSearch">
        {{ showTranslate() }}
      </button>
    </div>
  </div>
</template>

<script>
import { useContentStore } from "@/store/content";
import { ref, onMounted } from "vue";

export default {
  setup() {
    const store = useContentStore();
    const kmDifference = ref(0);
    onMounted(() => {
      zoomOutToSeeContent();
    });
    function noResultsTranslate() {
      const translations = {
        "agents": window.Drupal.t("agents", [], { context: "Search map no results" }),
        "workshops": window.Drupal.t("workshops", [], { context: "Search map no results" }),
      };
      const contentType = translations[store.contentType];
      return window.Drupal.t(
        `We did not find our @content-type in the location you were looking for - @address, so we extended the scope search within @km km.`,
        {
          "@address": store.searchedLocation?.address,
          "@km": kmDifference.value,
          "@content-type": contentType
        }
      );
    }
    function showTranslate() {
      return window.Drupal.t("Show");
    }
    function zoomOutToSeeContent() {
      const intervalId = setInterval(() => {
        if (store.getVisibleContents.length === 0) {
          store.zoom -= 1;
        } else {
          searchClosestPoint();
          clearInterval(intervalId);
        }
      }, 200);
    }
    function searchClosestPoint() {
      const lat1 = store.getVisibleContents[0].position.lat;
      const lat2 = store.searchedLocation.lat;
      const lon1 = store.getVisibleContents[0].position.lng;
      const lon2 = store.searchedLocation.lng;
      const R = 6371e3; // metres
      const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
      const φ2 = (lat2 * Math.PI) / 180;
      const Δφ = ((lat2 - lat1) * Math.PI) / 180;
      const Δλ = ((lon2 - lon1) * Math.PI) / 180;

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const d = R * c;
      kmDifference.value = Math.floor(d / 1000);
    }
    async function allowSearch() {
      store.changeMapOverlayVisibility();
      store.contentSearched = false;
    }
    return {
      store,
      allowSearch,
      kmDifference,
      zoomOutToSeeContent,
      noResultsTranslate,
      showTranslate,
    };
  },
};
</script>@/store/content